import { useKlarna } from '../useKlarna';

export interface KlarnaProps {
  dataKey: string;
  purchaseAmount?: string;
  dataTheme?: string;
  className?: string;
  id?: string;
}

export const KlarnaItem: React.FC<KlarnaProps> = ({
  dataKey,
  purchaseAmount,
  dataTheme,
  className,
  id,
}) => {
  const { showKlarna, locale } = useKlarna();

  if (!showKlarna) {
    return null;
  }

  return (
    <div className={className}>
      <klarna-placement
        id={id}
        data-key={dataKey}
        data-locale={locale}
        data-purchase-amount={purchaseAmount}
        data-theme={dataTheme}
      />
    </div>
  );
};

KlarnaItem.displayName = 'KlarnaItem';
